import { IOption } from "../models/options";
import { OptionsParam } from "../helper/type";
import { API_CENTRE } from "./config";
import { apiCallWithAuth } from "../helper/apiManager";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";
import { IOptionFilter } from "../models/filters/optionFilter";
import { IOptionPDTO } from "../models/dtos/optionPDTO";
import { IOptionForm } from "../models/forms/optionForm";


export default class OptionService extends _o2sService {

    protected static override mainUrl: string = API_CENTRE + "/api/v1/options";

    protected static override getUrlFilter<F extends IOptionFilter>(filter?: F): string {
        let url = super.getUrlFilter(filter as IFilter);

        if(filter != null) {

            if(filter.code != null)
                url += `&Code=${filter.code}`;

            if(filter.user != null)
                url += `&User=${filter.user}`;

            if(filter.centerId != null)
                url += `&CenterId=${filter.centerId}`;

            if(filter.societyId != null)
                url += `&SocietyId=${filter.societyId}`;

            if(filter.countryId != null)
                url += `&CountryId=${filter.countryId}`;
        }

        return url;
    }
    
    protected static override toDTO(obj: IOptionForm): IOptionPDTO {
        const dto = super.toDTO(obj) as IOptionPDTO;

        return dto;
    }
}
